<template>
  <div>
    <pageheader @logout="logout" @changeLang="switchLang" :default-index="defaultItem" :user-info="getUserInfo" :app-info="true"></pageheader>
    <pagesidebar :default-index="defaultItem"></pagesidebar>
    <div class="content-container">
      <transition name="fade">
        <router-view class="mp-height-add"></router-view>
      </transition>
    </div>
    <!-- <pagefooter></pagefooter> -->
  </div>
</template>
<script>
import pageheader from '@/layouts/header.vue'
import pagesidebar from '@/layouts/sideBar.vue'
import { mapState,mapGetters, mapActions, mapMutations } from 'vuex'
import * as util from '@/utils'
import store from '../vuex'
import * as Svc from '@/vuex/svc'
let request = false; 
export default {
  components: {
    pageheader,
    pagesidebar
  },
  data() {
    return {
      name: 'app',
      defaultItem: ''
    }
  },

  beforeRouteEnter(to, from, next) {
    if (request) {
      next();
      return;
    }
    request = true;
    Svc.getInfo().then(resp => {
      util.setStorage('pvsuser', { name: resp.username })
      store.commit('setName', resp.username)
      store.commit('setUserinfo', resp)
      if(resp.changepwd){
        next('/changepassword')
      }else{
        if(resp.adminlevel==2){
          if(to.name !== 'order' && to.name !== 'product' && to.name !== 'vechainorder' && to.name != 'vechainorderCreate' && to.name != 'orderDetail' && to.name !== 'productDetail') {
            next('/order?page=1')
          } else {
            next()
          }
        }else if(resp.adminlevel==3){
          if(to.name !== 'vechainorder' && to.name != 'vechainorderCreate') {
            next('/vechainorder?page=1')
          } else {
            next()
          }
        }else if(resp.adminlevel==4) {
          if(to.name !== 'order' && to.name != 'orderDetail') {
            next('/order?page=1')
          } else {
            next()
          }
        }else{
          next()
        }
      }
    })
   
  },
  
  methods: {
    ...mapMutations(['setUserinfo']),
    ...mapActions(['clearCookies', 'initInfo']),
    switchLang(lang) {
      const oldLang = util.getStorage('pvslang')
      if (oldLang === lang) return
      util.setStorage('pvslang', lang)
      window.location.reload()
    },
    logout() {
      this.clearCookies().then(() => {
        this.setUserinfo({})
        this.$router.push({name: 'login'})
      })
    }
  },
  computed: {
    ...mapState(["userinfo"]),
    ...mapGetters(['getUser','getUserInfo'])
  },
  created() {
    this.defaultItem = this.$route.meta.name
    
  },
  watch: {
    $route() {
      this.defaultItem = this.$route.meta.name
    }
    
  }
}
</script>



// WEBPACK FOOTER //
// Authorized.vue?105ad900